import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type EnrichedContentableModel from './enriched-contentable.ts';
import type { OutputData } from '@editorjs/editorjs';
import type Page from './page.ts';

export default class EnrichedContent extends Model {
  @attr declare content: OutputData;
  @attr declare contentType: string;
  @attr declare url: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('enriched-contentable', { async: false, polymorphic: true, inverse: null })
  declare enrichedContentable: EnrichedContentableModel;

  @belongsTo('page', { async: false, inverse: 'enrichedContents' })
  declare page: Page;

  [Type] = 'enriched-content' as const;
}
